// PluginContract_TableNode.ts
export const TableNodeContract = {
  pluginName: 'TablePlugin',
  nodeTypes: ['TableNode', 'TableRowNode', 'TableCellNode'],
  register: (editor: any) => {
    ['TableNode', 'TableRowNode', 'TableCellNode'].forEach((type) => {
      editor.registerNodeType?.(type);
    });
    console.log('🔌 [TablePlugin] Registered TableNode, TableRowNode, TableCellNode');
  },
};